<div>
  <ng-template #organization let-element>
    <div class="m-4 flex items-center space-x-4" *transloco="let t">
      <p class="flex-1">{{ element.name }}</p>
      <app-text-button
        class="flex-1"
        (click)="handleTakeOverButtonClick(element)"
      >
        {{ t('admin.organizations.takeOverButtonText') }}
      </app-text-button>
      <app-text-button class="flex-1">
        {{ t('admin.organizations.changeSettingsButtonText') }}
      </app-text-button>
      <app-text-button
        class="flex-1"
        [color]="buttonColor.RED"
        (click)="openDeleteDialog(element)"
      >
        {{ t('admin.organizations.deleteButtonText') }}
      </app-text-button>
    </div>
  </ng-template>

  <ng-template #deleteDialogContent>
    <div class="text-left" *transloco="let t">
      <p class="mb-4">
        {{ t('admin.organizations.deleteDialog.description') }}
        {{ t('admin.organizations.deleteDialog.confirmInstruction') }}
      </p>
      <ul class="mb-4 ml-5 list-disc space-y-2">
        <li>{{ reminderStripeText }}</li>
        <li>{{ reminderUnifiedText }}</li>
      </ul>
      <label class="mt-1.5 block text-sm font-medium" for="orgNameInput">
        {{ t('admin.organizations.deleteDialog.orgNameLabel') }}
      </label>
      <input
        id="orgNameInput"
        [formControl]="confirmationControl"
        [placeholder]="targetOrgName"
        class="mt-2 w-full rounded-lg border border-grey-midGrey p-2 placeholder:text-grey"
        type="text"
      />
      @if (
        confirmationControl.dirty &&
        confirmationControl.errors?.['nameMismatch']
      ) {
        <p class="mt-1 text-sm text-cancel">
          {{ t('admin.organizations.deleteDialog.orgNameError') }}
        </p>
      }
    </div>
  </ng-template>

  @if (organizations$ | async; as organizations) {
    <app-sep-table
      *transloco="let t"
      [columns]="columns"
      [dataSource]="organizations"
      [noDataText]="t('admin.organizations.noDataTableText')"
      [checkboxSelectedText]="t('admin.organizations.checkboxSelectedText')"
      [hasBulkActionButton]="true"
      [hideColumnHeader]="true"
    ></app-sep-table>
  }
</div>
